import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

// Searchable city dropdown, populated ONLY from ACTIVE cities configured by Platform Admin.
// If `value` is a city that has since been deactivated (still attached to an existing record),
// it is kept visible so the selection is preserved.
export default function CitySelect({ value = "", onChange, country = "Tanzania", testid = "city", placeholder = "Select city" }) {
  const [cities, setCities] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/config/cities", { params: { country } })
      .then((r) => setCities(r.data.map((c) => c.name)))
      .catch(() => setCities([]));
  }, [country]);

  const options = value && !cities.includes(value) ? [value, ...cities] : cities;
  const filtered = options.filter((c) => c.toLowerCase().includes(search.trim().toLowerCase()));

  return (
    <Select value={value} onValueChange={onChange} onOpenChange={(o) => !o && setSearch("")}>
      <SelectTrigger data-testid={testid} className="mt-1.5 bg-muted/40 border-black/10 h-11 rounded-xl">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <div className="p-2 sticky top-0 bg-popover z-10 border-b border-black/5">
          <Input
            data-testid={`${testid}-search`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            placeholder="Search cities…"
            className="h-9 bg-muted/40 border-black/10 rounded-lg text-sm"
          />
        </div>
        {filtered.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
        {filtered.length === 0 && (
          <p className="px-2 py-3 text-sm text-muted-foreground text-center" data-testid={`${testid}-empty`}>No cities found</p>
        )}
      </SelectContent>
    </Select>
  );
}
